import { render, staticRenderFns } from "./ComparisonTree.vue?vue&type=template&id=3abaa5ca&scoped=true"
import script from "./ComparisonTree.vue?vue&type=script&lang=js"
export * from "./ComparisonTree.vue?vue&type=script&lang=js"
import style0 from "./ComparisonTree.vue?vue&type=style&index=0&id=3abaa5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abaa5ca",
  null
  
)

export default component.exports